/**
 * File subnav-reload.js.
 *
 * Reloads page content on subnav click without refreshing page
 */

import { initPhotoCarousel } from "./image-carousel";
import { initA11yDialog } from "./dialog";

(function ($) {
  // If window larger than mobile
  if ($(window).width() > 783) {
    var subnavBar = $(".subnav");

    subnavBar.on("click", "a", function (e) {
      e.preventDefault();

      let lang = document.getElementsByTagName('html')[0].getAttribute('lang').substring(0, 2);
      let postId = $(this).parent().attr("data-post");
      let postLink = $(this).attr("href");
      let entryContent = $(".entry-content");
      let widgetArea = $(".widget-area");
      let contentArea = $(".content-area");

      fetch(`${window.location.origin}/wp-json/wp/v2/pages/${postId}?lang=${lang}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => {
          if (response.ok) {
            $(this).parent().siblings().removeClass("current_page_item");
            $(this).parent().addClass("current_page_item");
          }
          return response.json();
        })
        .then(function (data) {
          window.history.pushState({ href: postLink }, "", postLink);

          // Check if the content contains a gravity form, if it does, reload the page.
          let hasForm = data.content.rendered.search(/gform_wrapper/g);
          if ( hasForm !== -1 ) {
            location.reload();
            return;
          }

          // Otherwise, perform a dynamic page refresh.
          $(entryContent, widgetArea).fadeOut(250, function () {

			entryContent.html(data.content.rendered).fadeIn(250);
            widgetArea.remove();

            // Hero and subnav are part of post content so removing them below
            entryContent.find(".block--hero").remove();
            entryContent.find("#block--subnav").remove();

            if (data.template == "page-sidebar.php") {
              $("body").addClass("has-sidebar");
              contentArea
                .append(
                  "<aside id='secondary' class='widget-area'>" +
                    data.sidebar_content +
                    "</aside>"
                )
                .fadeIn(250);
            } else {
              $("body").removeClass("has-sidebar");
            }

            //Will trigger carousel re-init
            window.dispatchEvent( new Event( 'resize' ) );

			const photoCarouselImages = entryContent.find('.block--photo-carousel.display-style--inline .photo-carousel--images');
			if ( photoCarouselImages.length > 0 ) {
				console.log( '1', photoCarouselImages );
				console.log( '2', initPhotoCarousel );

				photoCarouselImages.each( initPhotoCarousel );
			}

            // dialog re-init
            initA11yDialog();
          });

        })
        .catch((error) => {
          console.error("Error:", error);
          location.href = postLink;
        });
    });
  }
})(window.jQuery);
